<template>
  <div class="index"  @click="goNext()" v-bind:style="{backgroundImage:'url(' + bg_img + ')'}">
      <h3 class="animated bounceInDown">我们的<span>服务</span></h3>
      <div  class="button-bg animated bounceInDown" v-bind:style="{backgroundImage:'url(' + button_img + ')'}">
          点击查看
      </div>
      <img class="index-bottom animated fadeInUp" src="https://cdn.hanlandglobal.com/h5-service-bg.png" />
  </div>
</template>

<script>
// @ is an alias to /src
import bg_img from '../assets/image/h5-bg.png'
import button_img from '../assets/image/button-bg.png'

export default {
  name: 'Home',
  data(){
    return {
      bg_img,
      button_img
    }
  },
  mounted(){
  },
  methods:{
    goNext(){
      this.$router.push('/service2')
    }
  }
}
</script>
<style lang='scss' scoped>
.index{
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100vh;
  position: relative;
}
h3{
  font-size: 0.54rem;
  font-family: SourceHan;
  color: #4d372e;
  text-align: center;
  letter-spacing: 1px;
  padding-top:13.6vh;
  span{
    font-size: 0.72rem;
  }
}
.index-bottom{
  width: 100%;
  height: 3.44rem;
  position: absolute;
  left: 0;
  bottom: 0;
}
.button-bg{
  width: 2rem;
  height: 0.62rem;
  background-repeat: no-repeat;
  background-size: 2rem 0.62rem;
  margin:0 auto;
  color: #f8eed5;
  font-size: 0.32rem;
  line-height: 0.58rem;
  margin-top: 1.34rem;
  font-weight: 700;
  font-family: SourceHan;
}
</style>
